<div class="container container-responsive narrow">
    <div (click)="back()" class="back">
        <i class="fa fa-chevron-left"></i>
        {{getBackText()}}
    </div>
    <div class="header">
        <div class="title">
            Produktdetails
        </div>
        <div class="nav">
            <div class="favorite">
                <button (click)="navigateToBookmarks()" class="bd-red-button-reversed">
                    <i class="fa fa-star"></i>
                    Merkliste
                </button>
            </div>
            <div class="vr"></div>
            <div class="customer-mode" (click)="share.customerMode = !share.customerMode">
                <img [src]="share.customerMode ? consts.customerModeOnImageSource : consts.customerModeOffImageSource"/>
                Kundenmodus
            </div>
        </div>
    </div>
    <div *ngIf="initialized" class="cards">
        <div class="details">
            <bdcp-product-image-viewer [product]="product"></bdcp-product-image-viewer>
            <div class="informations">
                <div class="content">
                    <div class="header">{{product?.modelNumber}}</div>
                    <div class="sub-header">{{product?.modelTitle}}</div>
                    <div class="features">
                        <div *ngFor="let feature of product?.keyFeatures | keyFeatureFilter: 6" class="feature">
                            <i class="fa fa-plus"></i>
                            {{feature}}
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <button (click)="folderService.open(product?.sku)">
                        <i class="fa fa-star"></i>
                        In die Merkliste
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="!share.customerMode" class="prices">
            <div class="header">
                <div class="title">
                    Preise* und Verfügbarkeit
                </div>
                <div class="action">
                    <button (click)="requestProject()">Projektanfrage starten</button>
                </div>
            </div>
            <div class="content">
                <bdcp-product-prices [product]="product"></bdcp-product-prices>
            </div>
        </div>
        <div *ngIf=" product?.features?.length" class="properties">
            <div class="header">
                <div class="title">
                    Eigenschaften und Spezifikationen
                </div>
                <div class="action">
                    <button (click)="requestCallback()">Presales Support</button>
                </div>
            </div>
            <div class="content">
                <bd-accordion>
                    <bd-accordion-tab *ngFor="let feature of product?.features" [title]="feature?.groupName">
                        <div *ngFor="let specification of feature?.specifications" class="information">
                            <div class="title">{{specification.title}}</div>
                            <div class="details">{{specification.details}}</div>
                        </div>
                    </bd-accordion-tab>
                </bd-accordion>
            </div>
        </div>
        <div *ngIf="product?.accessories?.length || product?.supplies?.length" class="accessoires">
            <div class="content">
                <div *ngIf="product?.accessories?.length" class="section">
                    <div class="title">
                        Zubehör
                    </div>

                    <bd-carousel-r class="carousel">
                        <div *ngFor="let a of product?.accessories" class="carousel-r-item">
                            <div class="image">
                                <img [src]="a.imageUrl" (error)="onImageError($event)"/>
                            </div>
                            <div class="title">
                                {{a.productModel}}
                            </div>
                            <div class="subtitle">
                                {{a.manufacturerName}}
                            </div>
                            <button (click)="navigateToProductDetails(a.manufacturerSKU)" class="product-details">
                                Produktdetails
                            </button>
                            <button (click)="folderService.open(a.manufacturerSKU)" class="favorite">In die Merkliste
                            </button>
                        </div>
                    </bd-carousel-r>
                </div>

                <div *ngIf="product?.supplies?.length" class="section">
                    <div class="title">
                        Verbrauchsmaterial
                    </div>
                    <bd-carousel-r class="carousel">
                        <div *ngFor="let a of product?.supplies" class="carousel-r-item">
                            <div class="image">
                                <img [src]="a.imageUrl" (error)="onImageError($event)"/>
                            </div>
                            <div class="title">
                                {{a.productModel}}
                            </div>
                            <div class="subtitle">
                                {{a.manufacturerName}}
                            </div>
                            <button (click)="navigateToProductDetails(a.manufacturerSKU)" class="product-details">
                                Produktdetails
                            </button>
                            <button (click)="folderService.open(a.manufacturerSKU)" class="favorite">In die Merkliste
                            </button>
                        </div>
                    </bd-carousel-r>
                </div>
            </div>
        </div>

        <div *ngIf="product?.solutions?.length" class="solutions">
            <div class="header">
                <div class="title">
                    Kompatible Lösungen
                </div>
            </div>
            <div class="content">
                <bd-carousel-r class="carousel">
                    <div *ngFor="let solution of product?.solutions" class="carousel-r-item">
                        <div class="header">
                            <img [src]="solution.imageUrl"/>
                        </div>
                        <div class="content">
                            <div class="title">{{solution.title}}</div>
                            <div class="description">{{solution.description}}</div>
                        </div>
                    </div>
                </bd-carousel-r>
            </div>
        </div>
    </div>
</div>
